import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { Flex } from 'reflexbox';

import { IEmailRecipient } from 'packages/kakapo-ui-services/models/Recipient';
import { IPromptableProps } from 'packages/kakapo-ui-application/hocs/withPrompt';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';
import Field, { FieldType } from 'packages/kakapo-ui-kit/components/forms/controls/Field';
import { SubmitButton } from 'packages/kakapo-ui-kit/components/buttons/PrimaryButton';
import { validator } from 'packages/kakapo-ui-services/factories/ValidatorFactory';
import { ValidationFunctions } from 'packages/kakapo-ui-services/services/common/ValidationService';

interface IProps extends IPromptableProps<IEmailRecipient> {}

export default function RecipientExternalPromptContainer({
	initialValues: { name },
	onSubmit,
	onCancel,
}: IProps) {
	const { t } = useTranslation();

	return (
		<ModalBackground>
			<Modal stackIndex={1}>
				<ModalHeader onCancel={onCancel}>
					<ModalHeaderTitle>{t('recipients.external.add.pageTitle', { name })}</ModalHeaderTitle>
				</ModalHeader>

				<ModalContent>
					<Formik
						initialValues={{
							name,
							email: '',
						}}
						validationSchema={validator.object({
							name: validator
								.string()
								.test('full-name', t('errors.fillInFullName'), ValidationFunctions.fullName)
								.required(),
							email: validator.string().email().required(),
						})}
						onSubmit={onSubmit}
					>
						<Form>
							<Field type={FieldType.Text} name="name" label="Full name" fullWidth />

							<Field type={FieldType.Email} name="email" label="Email" fullWidth />

							<Flex flexDirection="row" justifyContent="flex-end" flexWrap="wrap">
								<SubmitButton type="submit" value={t('recipients.external.add.buttonTitle')} />
							</Flex>
						</Form>
					</Formik>
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
